import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';

export const MainTopTrades: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { formatMessage } = useIntl();
  return (
    <div className="container px-0 mt-4">
      <div className="container px-0 py-4" data-e2e="top-trade">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="mb-0">{formatMessage({ id: 'discover.topTrades.title', defaultMessage: 'Top trades' })}</h1>
        </div>
      </div>
      <div className="container border-top pt-3">
        <div className="row">{children}</div>
      </div>
    </div>
  );
};
